module.exports = __webpack_public_path__ + "static/media/ajax-Loader.bcc92d16.gif";